
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, ViewChild } from '@angular/core';
import { AccountService } from '../../inner-menu-account.service';
import { MemberInfo, SharedModel } from '../../../shared/models/shared.model';
import { MessageShowComponent } from '../../../popup/message-show/message-show.component';
import { CommonService } from '../../../shared/service/shared.service';

@Component({ 
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent extends SiriusBaseComponent<any> {

    @ViewChild('messagePopup') messagePopup: MessageShowComponent;
    @ViewChild('BirthdateBox') birthdateBox: any; 
    private profileInfo: MemberInfo = null;
    private maskTel = ['(', /[5]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    public maskDate = SharedModel.dTarihiMask;
    private isSubmitted: boolean = false;
    private popUpMessage: string;
    private popUpTitle: string = "Uyarı"; 
    private isPhoneButtonClicked: boolean = false;
    currentPhone: string;
    isBirthDayActive: boolean = false;

    constructor(private accountService: AccountService, private commonService: CommonService) {
        super();
    }
    OnInit() {
        this.accountService.dataServiceInstance = this.dataService;
        this.getMemberInfo();
        let birthDayActiveValue = this.resourceService.getResource("askbirthday");
        if (birthDayActiveValue == "1") {
          this.isBirthDayActive = true;
        } 
  }

  private getMemberInfo() {
    let response = this.accountService.getCustomerInfo().toPromise();
    response.then((result) => {
      let name = ''
      let surname = ''
      if (this.profileInfo != null) {
        name = this.profileInfo.Name;
        surname = this.profileInfo.Surname;
      }
      this.profileInfo = <MemberInfo>result;
      this.currentPhone = this.profileInfo.PhoneNumber;
      if ((name != '' && name != this.profileInfo.Name) || (surname != '' && surname != this.profileInfo.Surname))
        this.commonService.loggedUserName.next(this.profileInfo.Name + ' ' + this.profileInfo.Surname);

      if (this.profileInfo.GetName) {
        this.popUpMessage = "Sistemimizde ad soyad bilginizde bir hata tespit ettik. Lütfen doğum tarihinizi girip  Güncelle butonunu tıklayınız. Bu işlemi tamamladıktan sonra satıcı veya alıcı olarak kayıt işlemlerinize devam edebilirsiniz.";
        this.messagePopup.showCancelButton = false;
        this.messagePopup.showPopup();
      }
    });
  }

    private updatePhone(e: any) {

        if (this.currentPhone == this.profileInfo.PhoneNumber.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "") ) {
            this.popUpMessage = "Lütfen güncellemek istediğiniz telefon numarasını giriniz.";
            this.messagePopup.showCancelButton = false;
            this.messagePopup.showPopup();
            return;
        }
        else {
            this.isPhoneButtonClicked = true;
            this.popUpMessage = "Mevcut telefon numaranızı güncellemek için  ve " + this.profileInfo.PhoneNumber + " numaralı telefona doğrulama kodu gönderilecektir. Devam etmek istiyor musunuz?";
            this.messagePopup.showPopup();
            this.messagePopup.showCancelButton = true;
        }
        e.preventDefault();
    }

    private updateEmail(e: any) {
        this.isPhoneButtonClicked = false; 
        this.updateCustomerInfo("E");
        e.preventDefault();
    }

  private updateName(e: any) {
    this.isPhoneButtonClicked = false;
    let isValidDate = false;
    if (this.isBirthDayActive) {
      this.profileInfo.BirthDate = this.birthdateBox.nativeElement.value
      var dateParts = this.profileInfo.BirthDate.split("/");
      var d = new Date(+dateParts[2], Number(dateParts[1]) - 1, +dateParts[0]);
      isValidDate = this.profileInfo.BirthDate != null && this.profileInfo.BirthDate != '' && d.toString() != 'Invalid Date' && d instanceof Date;
    }
    else {
      isValidDate = true;
      this.profileInfo.BirthDate = '01/01/2000';
    }
    if (!isValidDate) {
      this.popUpMessage = "Lütfen doğum tarihinizi giriniz.";
      this.messagePopup.showCancelButton = false;
      this.messagePopup.showPopup();
      return;
    }
    this.updateCustomerInfo("P");
    this.getMemberInfo();
    e.preventDefault();
  }

    private updateCustomerInfo(updateType: string) {
      this.profileInfo.UpdatedFieldInfo = updateType;
      let promise = this.accountService.updateCustomerInfo(this.profileInfo).toPromise();
        promise.then((result) => {
            this.messagePopup.showCancelButton = false;
            this.popUpMessage = result;
            this.messagePopup.showPopup();
        });
    }

    private onMessageAccepted() {
        if (this.isPhoneButtonClicked) {
            this.isPhoneButtonClicked = false;
            let promise = this.accountService.updatePhoneNumber(this.profileInfo).toPromise();
            promise.then((result) => {
                if (result == 'OK')
                    this.commonService.logOutClient();
                else {
                    this.messagePopup.showCancelButton = false;
                    this.popUpMessage = result;
                    this.messagePopup.showPopup();
                }
            });
        }
    }
}
